/* CUSTOM KIYO START — kiyo-produktdetails.js
   Tab switching for the Kiyo Produktdetails section. Uses document-level event
   delegation, so sections re-rendered by the Theme Editor need no re-init.
   Selecting a block inside a hidden tab in the editor reveals that tab.
   Also inlines the technical drawing (SVG) of "Tab: Abmessungen". */
(function () {
  function activate(root, index) {
    index = String(index);
    root.querySelectorAll('[data-kpd-tab]').forEach(function (btn) {
      var on = btn.getAttribute('data-kpd-tab') === index;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      btn.setAttribute('tabindex', on ? '0' : '-1');
    });
    root.querySelectorAll('[data-kpd-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-kpd-panel') !== index;
      // A drawing inlined while its panel was hidden measured 0×0; size its labels now that it is visible
      // (ResizeObserver does the same, but only once the browser has painted a frame).
      if (!panel.hidden) panel.querySelectorAll('.kpd__drawing--inline').forEach(fitLabels);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kpd-tab]');
    if (!btn) return;
    var root = btn.closest('[data-kpd]');
    if (!root) return;
    activate(root, btn.getAttribute('data-kpd-tab'));
  });

  // WAI-ARIA tabs pattern: arrows move to the previous/next tab (wrapping), Home/End to the first/last
  document.addEventListener('keydown', function (event) {
    var key = event.key;
    if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') return;
    var btn = event.target.closest ? event.target.closest('[data-kpd-tab]') : null;
    if (!btn) return;
    var tabs = Array.prototype.slice.call(btn.parentNode.querySelectorAll('[data-kpd-tab]'));
    var last = tabs.length - 1;
    var current = tabs.indexOf(btn);
    var next;
    if (key === 'Home') next = 0;
    else if (key === 'End') next = last;
    else if (key === 'ArrowRight') next = current === last ? 0 : current + 1;
    else next = current === 0 ? last : current - 1;
    event.preventDefault();
    if (next === current) return;
    tabs[next].focus();
    tabs[next].click();
  });

  /* Technical drawings: fetch the SVG, crop the viewBox to the drawn content and
     inline it, so CSS controls line weight, label size and colour. */
  // Variant images: the first tab's picture follows the selected option value
  // (blocks "Variantenbild"). The theme fires shopify:product:select on the
  // product section (bubbles to document); its promise resolves with the variant.
  document.addEventListener('shopify:product:select', function (event) {
    if (!event.promise) return;
    if (event.target instanceof Element && event.target.closest('product-card')) return;
    event.promise.then(function (result) {
      var detail = result && result.detail;
      var variant = detail && detail.resource;
      if (!variant || !variant.options) return;
      document.querySelectorAll('[data-kpd] [data-kpd-variant-map]').forEach(function (node) {
        if (detail.productId && node.dataset.kpdProduct && String(detail.productId) !== String(node.dataset.kpdProduct)) return;
        var map;
        try { map = JSON.parse(node.textContent); } catch (err) { return; }
        var img = node.parentElement.querySelector('img[data-kpd-variant-img]');
        if (!img) return;
        var url = null;
        variant.options.forEach(function (opt) {
          var key = String(opt).trim().toLowerCase();
          if (!url && map[key]) url = map[key];
        });
        if (!url) url = img.dataset.kpdDefault;
        if (!url || url === img.dataset.kpdCurrent) return;
        var widths = (img.getAttribute('srcset') || '').split(',').map(function (c) {
          return parseInt((c.trim().split(/\s+/)[1] || ''), 10);
        }).filter(function (n) { return n > 0; });
        img.src = url;
        if (widths.length) {
          img.srcset = widths.map(function (n) {
            return url.replace(/([?&])width=\d+/, '$1width=' + n) + ' ' + n + 'w';
          }).join(', ');
        } else {
          img.removeAttribute('srcset');
        }
        img.dataset.kpdCurrent = url;
      });
    }).catch(function () {});
  });

  function inlineDrawing(host) {
    if (host.dataset.kpdSvgState) return;
    host.dataset.kpdSvgState = 'loading';
    var url = host.getAttribute('data-kpd-svg').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'image/svg+xml');
        var svg = doc.documentElement;
        if (!svg || svg.nodeName.toLowerCase() !== 'svg') throw new Error('not an svg');
        svg = document.importNode(svg, true);
        // Only geometry is wanted: no page-wide <style>, no scripts, no tooltip <title>, no on* handlers
        Array.prototype.forEach.call(svg.querySelectorAll('style, script, title, desc, foreignObject'), function (n) { n.remove(); });
        Array.prototype.forEach.call(svg.querySelectorAll('*'), function (el) {
          Array.prototype.slice.call(el.attributes).forEach(function (a) {
            if (/^on/i.test(a.name) || (a.name === 'href' && /^\s*javascript:/i.test(a.value))) el.removeAttribute(a.name);
          });
        });
        var probe = document.createElement('div');
        probe.style.cssText = 'position:absolute;left:-9999px;top:0;width:1000px;visibility:hidden;';
        probe.appendChild(svg);
        document.body.appendChild(probe);
        var box = svg.getBBox();
        if (box.width > 0 && box.height > 0) {
          var m = box.width * 0.02;
          svg.setAttribute('viewBox', [box.x - m, box.y - m, box.width + 2 * m, box.height + 2 * m].join(' '));
        }
        /* Line hierarchy: the heaviest stroke in the file = object outlines, thinner
           strokes = dimension lines; filled shapes (arrowheads) follow the dimension
           lines. CSS assigns the on-screen weights and colours per class. */
        var stroked = [], strokeWidths = [];
        Array.prototype.forEach.call(svg.querySelectorAll('path, line, polyline, polygon, rect, circle, ellipse'), function (el) {
          var cs = getComputedStyle(el);
          if (!cs.stroke || cs.stroke === 'none') return;
          var w = parseFloat(cs.strokeWidth);
          stroked.push(el);
          strokeWidths.push(isNaN(w) ? 1 : w);
        });
        var maxWidth = strokeWidths.reduce(function (max, w) { return Math.max(max, w); }, 0) || 1;
        stroked.forEach(function (el, i) {
          el.classList.add(strokeWidths[i] / maxWidth < 0.75 ? 'kpd-svg-dim' : 'kpd-svg-line');
        });
        Array.prototype.forEach.call(svg.querySelectorAll('path, polygon, rect, circle, ellipse'), function (el) {
          var cs = getComputedStyle(el);
          if (cs.fill && cs.fill !== 'none' && (!cs.stroke || cs.stroke === 'none')) el.classList.add('kpd-svg-fill');
        });
        probe.remove();
        svg.removeAttribute('width');
        svg.removeAttribute('height');
        svg.setAttribute('role', 'img');
        var img = host.querySelector('img');
        if (img && img.alt) svg.setAttribute('aria-label', img.alt);
        svg.classList.add('kpd__drawing', 'kpd__drawing--inline');
        if (img) img.replaceWith(svg); else host.appendChild(svg);
        host.dataset.kpdSvgState = 'done';
        fitLabels(svg);
        if (window.ResizeObserver) new ResizeObserver(function () { fitLabels(svg); }).observe(host);
      })
      .catch(function () { host.dataset.kpdSvgState = 'failed'; });
  }
  /* The drawings come in different unit scales (a cube is ~600 units wide, a lowboard
     ~2600), so a fixed SVG font-size would render labels anywhere between 7px and 34px.
     Compute the units that give the target pixel size at the current rendered scale. */
  function fitLabels(svg) {
    var vb = svg.viewBox && svg.viewBox.baseVal;
    var rect = svg.getBoundingClientRect();
    if (!vb || !vb.width || !rect.width) return;
    var scale = Math.min(rect.width / vb.width, rect.height / vb.height);
    var target = window.innerWidth < 750 ? 11 : 13;
    svg.style.setProperty('--kpd-label', (target / scale).toFixed(2) + 'px');
  }

  // Tab images in hidden panels carry loading="lazy" and would only load when their tab opens
  // (display:none = never in view). Two cheap triggers instead of loading them with the page:
  //   1. intent — pointer/touch/focus on a tab chip loads that tab's images right away (a few
  //      hundred ms before the click lands),
  //   2. idle — once the section itself is on screen and the browser is idle, the remaining
  //      hidden images are fetched at low priority.
  // Visitors who never reach the section never download them.
  function loadPanelImages(panel, priority) {
    if (!panel) return;
    panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (priority) img.setAttribute('fetchpriority', priority);
      img.loading = 'eager';
    });
  }
  function loadAllHiddenPanels(root) {
    if (root.dataset.kpdPreloaded) return;
    root.dataset.kpdPreloaded = '1';
    root.querySelectorAll('[data-kpd-panel][hidden]').forEach(function (p) { loadPanelImages(p, 'low'); });
  }
  function panelForTab(btn) {
    var root = btn.closest('[data-kpd]');
    return root && root.querySelector('[data-kpd-panel="' + btn.getAttribute('data-kpd-tab') + '"]');
  }
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-kpd-tab]') : null;
      if (btn) loadPanelImages(panelForTab(btn), 'high');
    }, { capture: true, passive: true });
  });
  function watchSections() {
    var roots = document.querySelectorAll('[data-kpd]');
    if (!roots.length || !window.IntersectionObserver) return;
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 800); };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        idle(function () { loadAllHiddenPanels(en.target); }, { timeout: 4000 });
      });
    }, { threshold: 0.15 });
    roots.forEach(function (r) { io.observe(r); });
  }

  function inlineAll() {
    watchSections();
    document.querySelectorAll('[data-kpd-svg]').forEach(inlineDrawing);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inlineAll); else inlineAll();
  document.addEventListener('shopify:section:load', inlineAll);

  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target && event.target.closest ? event.target.closest('[data-kpd-panel]') : null;
    if (!panel) return;
    activate(panel.closest('[data-kpd]'), panel.getAttribute('data-kpd-panel'));
  });
})();
/* CUSTOM KIYO END */
